<header class="lu-header">
  <div class="lu-container lu-header__inner">
    <a [href]="tenant.content.headerHref" class="lu-header__brand">
      <img class="lu-header__logo" src="assets/media/logo/logo_lu.svg" [alt]="tenant.content.organisationName">
      <span class="lu-header__org">{{tenant.content.organisationName}}</span>
    </a>
    <nav class="lu-header__nav">
      <ng-container [ngTemplateOutlet]="navLinks"/>
    </nav>
    <button class="lu-header__burger" type="button" (click)="navOpen = !navOpen"
            [class.is-open]="navOpen" [attr.aria-expanded]="navOpen" aria-label="Menü">
      <span></span><span></span><span></span>
    </button>
  </div>
</header>

@if (navOpen) {
  <nav class="lu-offcanvas" (click)="navOpen = false">
    <ng-container [ngTemplateOutlet]="navLinks"/>
  </nav>
}

<ng-template #navLinks>
  @if (signedIn) {
    <a routerLink="" routerLinkActive="is-active" [routerLinkActiveOptions]="{exact: true}">Meine Ausschreibungen</a>
    <div class="lu-account" [class.is-open]="accountOpen">
      <button type="button" class="lu-account__toggle" [attr.aria-expanded]="accountOpen"
              (click)="accountOpen = !accountOpen; $event.stopPropagation()">
        <svg class="lu-account__icon" viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="8" r="4"/>
          <path d="M4 20c0-4 3.6-6 8-6s8 2 8 6"/>
        </svg>
        <span class="lu-account__name">{{userName}}</span>
      </button>
      @if (accountOpen) {
        <div class="lu-account__menu">
          @for (link of tenant.content.account.menuLinks; track link.path) {
            <a [href]="link.path" target="_blank" rel="noopener">{{link.label}}</a>
          }
          <a href="oauth2/logout" class="lu-account__logout">Abmelden</a>
        </div>
      }
    </div>
  } @else {
    <a class="lu-login-btn" [href]="tenant.content.loginUrl">{{tenant.content.landing.loginButtonLabel}}</a>
  }
</ng-template>

<main class="lu-main">
  <div class="lu-container">
    <div class="layout_section">
      @if (pageTitle | async; as title) {
        <h1 class="dah-heading" id="anchorContent">{{title}}</h1>
      }
      <dah-breadcrumb-nav/>
      <router-outlet/>
    </div>
  </div>
</main>

<footer class="lu-footer">
  <div class="lu-container lu-footer__inner">
    <div class="lu-footer__links">
      @for (link of tenant.content.footer.legalLinks; track link.path) {
        <a [href]="link.path" target="_blank" rel="noopener">{{link.label}}</a>
      }
    </div>
    <span class="lu-footer__copyright">© {{year}} {{tenant.content.copyright}}</span>
  </div>
</footer>
